/**
 * 数量入力欄の入力制御（NHP_EC_SHOPIFY-94）
 *
 * 対象: data-quantity-input が付いた入力欄（商品詳細ページ・カートページ）
 *
 *   1. 「0」「空欄」を入力した場合は data-min（既定1）に戻す
 *   2. 在庫数（data-max）を超える値を入力した場合は在庫数に戻す
 *   3. 数字以外は受け付けない
 *
 * 補正のタイミング
 *   - 数字以外の除去と在庫数の上限は入力中に即座に反映する
 *   - 0・空欄の補正は入力欄から離れたときに行う
 *     （入力中に補正すると、値を全部消してから打ち直す操作ができなくなるため）
 *
 * jQuery に依存させていない。読み込み順や外部CDNの障害に影響されないようにするため。
 */
(function () {
  var SELECTOR = '[data-quantity-input]';

  function getMin(el) {
    var min = parseInt(el.getAttribute('data-min'), 10);
    return isNaN(min) || min < 1 ? 1 : min;
  }

  function getMax(el) {
    var max = parseInt(el.getAttribute('data-max'), 10);
    // 在庫が0以下のときは上限なしとして扱う。
    // 0に補正すると、その商品を含むカートが一切注文できなくなるため。
    return isNaN(max) || max < 1 ? null : max;
  }

  // 入力中: 数字以外を除去し、在庫数を超えていれば在庫数に丸める
  function sanitize(el) {
    var value = el.value.replace(/[^0-9]/g, '');
    var max = getMax(el);

    if (value !== '' && max !== null && parseInt(value, 10) > max) {
      value = String(max);
    }
    if (el.value !== value) {
      el.value = value;
    }
  }

  // 確定時: 空欄・0 を最小値に戻す
  function commit(el) {
    sanitize(el);
    if (el.value === '' || parseInt(el.value, 10) < getMin(el)) {
      el.value = String(getMin(el));
    }
  }

  function target(node) {
    return node && node.closest ? node.closest(SELECTOR) : null;
  }

  document.addEventListener('input', function (e) {
    var el = target(e.target);
    if (el) sanitize(el);
  });

  // blur はバブリングしないためキャプチャフェーズで拾う
  ['change', 'blur'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var el = target(e.target);
      if (el) commit(el);
    }, true);
  });

  // 送信直前の保険。入力イベントを取りこぼしていても、送信される値は必ず補正しておく
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelectorAll) return;
    Array.prototype.forEach.call(form.querySelectorAll(SELECTOR), commit);
  }, true);
})();
